module.exports = __webpack_public_path__ + "img/about1.e434f2aa.png";